/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TokenResponse } from './tokenResponse';

export type LoginResponseToken = TokenResponse | string;
